import { render, staticRenderFns } from "./posts-table-item.vue?vue&type=template&id=f1f1fe0e&scoped=true&"
import script from "./posts-table-item.vue?vue&type=script&lang=js&"
export * from "./posts-table-item.vue?vue&type=script&lang=js&"
import style0 from "./posts-table-item.vue?vue&type=style&index=0&id=f1f1fe0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f1fe0e",
  null
  
)

export default component.exports